import { Component, h, Element } from "@stencil/core"
import { getAppearance } from "../../core/helpers/webcomponent-helpers"

@Component({
  tag: "sdx-backdrop",
  styleUrl: "backdrop.scss",
  shadow: true,
})
export class Backdrop {
  @Element() public el!: HTMLSdxBackdropElement

  private getComponentClassNames() {
    return {
      component: true,
      [getAppearance(this.el)]: true,
    }
  }

  public render() {
    return (
      <div class={this.getComponentClassNames()}>
        <div class="background"></div>

        <div class="slot row no-gutters flex-items-xs-center flex-items-xs-bottom flex-items-sm-middle">
          <slot />
        </div>
      </div>
    )
  }
}
